export default __webpack_public_path__ + "static/media/elements.e1ef7996.svg";